import { Component, computed, contentChildren, input, InputSignal, Signal } from '@angular/core';
import { TableCellComponent } from '../table-cell/table-cell.component';

@Component({
    selector: 'app-table-row',
    templateUrl: './table-row.component.html',
    standalone: true
})
export class TableRowComponent {
    private cells = contentChildren(TableCellComponent);
    public pillColor: InputSignal<string> = input('var(--shs-orange)');
    public gridTemplateColumns: Signal<string> = computed(() => {
        return this.cells()
            .map((cell) => `minmax(${cell.minWidth()}, ${cell.width()})`)
            .join(' ');
    });
}
